module.exports = __webpack_public_path__ + "assets/img/thumb-EISS-Super-eBook.8e42e7f3.png";